import { Injectable } from "@angular/core";
import { HttpService } from "../services/http.service";
import { map } from "rxjs";
import { ResponseApi } from "../models/response-api.model";
import { DataService } from "../config/app.config";

@Injectable({
    providedIn: 'root',
})
export class NotificationRepository {
    constructor(private httpService: HttpService) { }
    public getByPage() {
        return this.httpService.getAuthorization(DataService.API_GET_NOTIFICATION).pipe(
            map((res: ResponseApi<any>) => {
                return res;
            })
        );
    }
    public readNotification(id : string){
        return this.httpService.putAuthorization(DataService.API_READ_NOTIFICATION + `/${id}`, {}).pipe(
            map((res: ResponseApi<any>) => {
                return res;
            })
        );
    }
    public readAllNotification(req:any) {
        return this.httpService.postAuthorization(DataService.API_READ_ALL_NOTIFICATION, req).pipe(
            map((res: ResponseApi<any>) => {
                return res;
            })
        );
    }
}